module.exports = __webpack_public_path__ + "static/img/undraw_manage_chats_ylx0.afb46eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/undraw_manage_chats_ylx0.svg
// module id = Mcyl
// module chunks = 1